interface StatusBadgeProps {
  status: 'Approved' | 'Pending' | 'Reject';
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const statusClasses = {
    Approved: 'bg-green-100 text-green-800 border-green-200',
    Pending: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    Reject: 'bg-red-100 text-red-800 border-red-200',
    'Pending Review': 'bg-yellow-100 text-yellow-800 border-yellow-200',
  };

  return (
    <span
      className={`inline-block px-2 py-1 text-xs font-semibold ml-2 rounded border ${statusClasses[status]}`}
    >
      {status}
    </span>
  );
};
